import React, { useState, useEffect } from "react";
import "./OnionBuy.css"; // Assuming a new CSS file for light buyers styles
import { useAuth } from "./AuthContext";
import { Link } from "react-router-dom";
import Whyglobal from "../Components/Whyglobal";
import BuyerSide from "./BuyerSidebuyer";

const LightBuyers = [
  {
    name: "Ravi Kumar",
    email: "ravi.kumar@gmail.com",
    mobileNumber: "9812345678",
    locationandDate: "Delhi, 21-11-2024",
    lookingFor: "Looking to purchase bulk LED lights for commercial buildings.",
    productOrService: "LED Lights",
    quantity: 2000,
    unit: "pieces",
    _id: "unique_id_for_led_light_buyer_1",
  },
  {
    name: "Suman Verma",
    email: "suman.verma@gmail.com",
    mobileNumber: "9701234567",
    lookingFor: "Need LED bulbs for residential use.",
    productOrService: "LED Bulbs",
    locationandDate: "Mumbai, 19-11-2024",
    quantity: 1500,
    unit: "pieces",
  },
  {
    name: "Pooja Sharma",
    email: "pooja.sharma@gmail.com",
    mobileNumber: "9934567890",
    lookingFor: "Bulk purchase of energy-efficient bulbs for stores.",
    productOrService: "Energy Efficient Bulbs",
    locationandDate: "Bangalore, 18-11-2024",
    quantity: 1200,
    unit: "pieces",
  },
  {
    name: "Amit Patel",
    email: "amit.patel@gmail.com",
    mobileNumber: "9856784321",
    lookingFor: "Interested in LED tube lights for offices.",
    productOrService: "LED Tube Lights",
    locationandDate: "Chennai, 17-11-2024",
    quantity: 1000,
    unit: "pieces",
  },
  {
    name: "Priya Singh",
    email: "priya.singh@gmail.com",
    mobileNumber: "9887654321",
    lookingFor: "Bulk purchase of decorative LED lights for events.",
    productOrService: "Decorative LED Lights",
    locationandDate: "Kolkata, 20-11-2024",
    quantity: 800,
    unit: "pieces",
  },
  {
    name: "Rajesh Gupta",
    email: "rajesh.gupta@gmail.com",
    mobileNumber: "9802345678",
    lookingFor: "Need solar-powered LED lights for garden.",
    productOrService: "Solar LED Lights",
    locationandDate: "Hyderabad, 22-11-2024",
    quantity: 500,
    unit: "pieces",
  },
  {
    name: "Neelam Yadav",
    email: "neelam.yadav@gmail.com",
    mobileNumber: "9945678901",
    lookingFor: "Looking for LED strip lights for interior decoration.",
    productOrService: "LED Strip Lights",
    locationandDate: "Lucknow, 23-11-2024",
    quantity: 600,
    unit: "meters",
  },
  {
    name: "Vikash Kumar",
    email: "vikash.kumar@gmail.com",
    mobileNumber: "9812374650",
    lookingFor: "Bulk purchase of floodlights for construction sites.",
    productOrService: "LED Floodlights",
    locationandDate: "Pune, 24-11-2024",
    quantity: 100,
    unit: "pieces",
  },
];

const LightBuy = () => {
  const { userId } = useAuth();
  const [userIsPremium, setUserIsPremium] = useState(false);
  const [shownNumbers, setShownNumbers] = useState([]);
  const [leadsViewed, setLeadsViewed] = useState(0);

  useEffect(() => {
    if (!userId) return;

    const storedViewedLeads =
      JSON.parse(localStorage.getItem(`lightViewedLeads_${userId}`)) || [];
    setShownNumbers(storedViewedLeads);

    fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/getUserWithPremiumStatus/${userId}`
    )
      .then((response) => response.json())
      .then((data) => {
        setUserIsPremium(data.isPremium);
        setLeadsViewed(data.leadsViewed);
        console.log("Premium Status:", data.isPremium);
      })
      .catch((error) => {
        console.error("Error fetching user information:", error);
      });
  }, [userId]);

  const toggleNumber = async (index) => {
    if (!userIsPremium) return;

    if (leadsViewed >= 25) {
      alert("You have reached the limit of 25 leads viewed per month.");
      return;
    }

    if (shownNumbers.includes(index)) return;

    const updatedShownNumbers = [...shownNumbers, index];
    setShownNumbers(updatedShownNumbers);

    localStorage.setItem(
      `lightViewedLeads_${userId}`,
      JSON.stringify(updatedShownNumbers)
    );

    const buyer = LightBuyers[index];

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/incrementLeadsViewed/${userId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            buyerName: buyer.name,
            mobileNo: buyer.mobileNumber,
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setLeadsViewed(data.leadsViewed);
      } else {
        const errorData = await response.json();
        console.error("Error incrementing leads viewed:", errorData.error);
      }
    } catch (error) {
      console.error("Error incrementing leads viewed:", error.message);
    }
  };

  return (
    <>
      <div className="container">
        <ol className="breadcrumb">
          <li
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "5px 30px",
            }}
            className="breadcrumb-item"
          >
            <Link to={"/"}>Home</Link>
          </li>
          <li
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "5px -25px",
            }}
          >
            /
          </li>
          <li
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "5px 30px",
            }}
            className="breadcrumb-item active"
          >
            Light Product Buyers
          </li>
        </ol>
      </div>
      <div className="containersx">
        <div style={{ width: "200px", padding: "10px" }} className="browsers">
          <h3 style={{ marginTop: "30px" }}>Browse by Category</h3>
          <ul className="flt-list cust-scroll" id="category-lists">
            <li>
              <Link to="#">All Lights</Link>
            </li>
            <li>
              <Link to="#">LED Lights</Link>
            </li>
            <li>
              <Link to="#">LED Bulbs</Link>
            </li>
            <li>
              <Link to="#">Energy Efficient Bulbs</Link>
            </li>
            <li>
              <Link to="#">LED Tube Lights</Link>
            </li>
            <li>
              <Link to="#">Decorative LED Lights</Link>
            </li>
            <li>
              <Link to="#">Solar LED Lights</Link>
            </li>
            <li>
              <Link to="#">LED Strip Lights</Link>
            </li>
            <li>
              <Link to="#">LED Floodlights</Link>
            </li>
          </ul>
        </div>
        <div className="buyers">
          {LightBuyers.map((buyer, index) => (
            <div key={index} className="buyer-card">
              <h2 style={{ color: "red" }}>{buyer.lookingFor}</h2>
              <p>
                <strong>Buyer Name:</strong> {buyer.name}
              </p>
              <p>
                <strong>Quantity:</strong> {buyer.quantity} {buyer.unit}
              </p>
              <p>
                <strong>Location & Date:</strong> {buyer.locationandDate}
              </p>
              <p>
                <strong>Mobile No.:</strong>{" "}
                {userIsPremium
                  ? shownNumbers.includes(index)
                    ? buyer.mobileNumber
                    : "********"
                  : "********"}
              </p>
              <div style={{ display: "flex", gap: "10px" }}>
                {userIsPremium && (
                  <button
                    className="detail-btn"
                    style={{
                      padding: "5px 10px",
                      background: "#f7f1f1",
                      color: "orange",
                      borderRadius: "3px",
                      cursor: "pointer",
                    }}
                    onClick={() => toggleNumber(index)}
                  >
                    Click to see
                  </button>
                )}
              </div>
              <div className="btns-imp">
                <Link to={"/login"}>
                  <button className="detailing-btn">View More</button>
                </Link>
                <Link to={"/register-Company"}>
                  <button className="regis-btn">Register Now</button>
                </Link>
              </div>
            </div>
          ))}
        </div>
        <BuyerSide />
      </div>
    </>
  );
};

export default LightBuy;
